import React from 'react';
import { useT } from 'talkr';
import s from './index.module.scss';

function SwitcherItem ({
	value, currentValue, actionOnChange, disableFromFocus
}) {
	const { T } = useT();
	const valueFromCurent = currentValue === 'in' ? 'ft' : currentValue;
	
	return (
		<button data-prevent-from-blur type="button" className={`${s.value} ${value === valueFromCurent ? s.selected : ''}`} onClick={() => actionOnChange(value)} tabIndex={disableFromFocus ? -1 : ''}>
			{T(`value_${value}`)}
		</button>
	);
}

function Switcher ({
	value1, value2, currentValue, actionOnChange, className, disableFromFocus
}) {
	return (
		<div className={`${s.switcher} ${className}`}>
			<SwitcherItem value={value1} currentValue={currentValue} actionOnChange={actionOnChange} disableFromFocus={disableFromFocus} />
			<SwitcherItem value={value2} currentValue={currentValue} actionOnChange={actionOnChange} disableFromFocus={disableFromFocus} />
		</div>
	);
}

export default Switcher;
